var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,13.3h5.3v-1.8H0V13.3z M0,2.7v1.8h16V2.7H0z M0,8.9h10.7V7.1H0V8.9z","fill":"currentColor"}));
}

Filter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Filter;

Filter.default = Filter;
